import { cn } from '@/lib/utils';
import { useI18n } from '@/locales/client';
import Link from 'next/link';
import { SubRoute } from '../types';

type SubmenuItemProps = {
  route: SubRoute;
  isSelected: boolean;
  onClick: () => void;
};

export function SubmenuItem({ route, isSelected, onClick }: SubmenuItemProps) {
  const t = useI18n();
  const comingSoonText = t('navigation.comingSoon');

  if (route.comingSoon) {
    return (
      <div
        className={cn(
          'relative flex cursor-not-allowed items-center gap-3 rounded-md p-3 text-sm opacity-70 transition-colors duration-150',
          isSelected ? 'bg-gray-100 dark:bg-gray-700' : '',
          'group'
        )}
      >
        <route.icon
          className={cn(
            'mt-0.5 h-4 w-4 flex-shrink-0',
            isSelected ? 'text-primary' : 'text-gray-500 dark:text-gray-400'
          )}
          aria-hidden='true'
        />
        <div className='min-w-0 flex-1'>
          <span className='text-xs text-gray-500 dark:text-gray-400'>
            {comingSoonText}
          </span>
          <p
            className={cn(
              'truncate font-medium',
              isSelected
                ? 'text-gray-900 dark:text-white'
                : 'text-gray-700 dark:text-gray-300'
            )}
          >
            {route.title}
          </p>
          {route.description && (
            <p className='line-clamp-2 text-xs text-gray-500 dark:text-gray-400'>
              {route.description}
            </p>
          )}
        </div>
      </div>
    );
  }

  return (
    <Link
      href={route.path}
      onClick={onClick}
      className={cn(
        'flex items-center gap-3 rounded-md p-3 text-sm transition-colors duration-150',
        isSelected
          ? 'bg-gray-100 dark:bg-gray-700'
          : 'hover:bg-gray-50 dark:hover:bg-gray-800',
        'group'
      )}
    >
      <route.icon
        className={cn(
          'mt-0.5 h-4 w-4 flex-shrink-0',
          isSelected
            ? 'text-primary'
            : 'text-gray-500 group-hover:text-gray-700 dark:text-gray-400 dark:group-hover:text-gray-300'
        )}
        aria-hidden='true'
      />
      <div className='min-w-0 flex-1'>
        <p
          className={cn(
            'truncate font-medium',
            isSelected
              ? 'text-gray-900 dark:text-white'
              : 'text-gray-700 dark:text-gray-300'
          )}
        >
          {route.title}
        </p>
        {route.description && (
          <p className='line-clamp-2 text-xs text-gray-500 dark:text-gray-400'>
            {route.description}
          </p>
        )}
      </div>
    </Link>
  );
}
